export default __webpack_public_path__ + "static/media/Illustrations.abf724d1.png";